module.exports = __webpack_public_path__ + "static/media/explore_02.dc261eeb.jpg";